import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { App } from './App.js';
import { store } from './stores/mainStore';

import * as serviceWorker from './serviceWorker';
import {i18nReady, i18n} from './i18n';
// import { i18n } from './i18n';

localStorage.clear();

// document.getElementById('loadLog').innerHTML += " * JS * "
window.gtag('event', 'logic-loaded', {event_label: 'timing', start: window.startTime, end: Date.now()});

const config = window.dodConfig;

// window.WrapperApp.postMessage("get-info");

window.setPersistentStorage = function(key, value){
	try {
		value = value.toString();
		localStorage.setItem(key, value);
		if(store && store.localStorageSynced){
			var wrapperStorage = JSON.stringify(localStorage);
			// console.log('wrapperstorage set:' + wrapperStorage);
			window.WrapperApp.postMessage(`set-localstorage?json=${wrapperStorage}`);
		}
	} catch (error) {
		console.warn('wrapperstorage error' + error);
	}
}

config.isLandscape = false; // config.orientation === 'landscape';

window.restartWebview = function (){
	localStorage.setItem('restart', 'yes');
	window.location.reload();
}

//internationalization
i18nReady.then((err,t) => {
	if(err){
		console.log(err);
	}
	console.log('i18next', i18n.language)
	const supportedLanguages = ['fr','de','es','it','en'];
	//if the settings have never been changed, use the detected language
	if(!localStorage.getItem('settings') || supportedLanguages.indexOf(store.settings.language) === -1){
		var lang = 'en';
		var i18nLang = i18n.language.split('-')[0];
		if(supportedLanguages.indexOf(i18nLang) > -1){
			lang = i18nLang;
		}
		store.changeSetting('language', lang);
	}
});


	// document.getElementById('loadLog').innerHTML += " * mount * ";
	document.body.removeChild(document.getElementById('loadMsg'));
	i18nReady.then(() => {
		// document.getElementById('loadLog').innerHTML += " * i18n * "
		ReactDOM.render(<App/>, document.getElementById('root'));
	})
	.catch(() => {
		window.location.reload();
	});

serviceWorker.unregister();
